import React from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import {
  HeroRoot,
  HeroContent,
  HeroTitle,
  HeroSubtitle,
  HeroBadge,
  HeroImage,
  HeroImageMobile,
  HeroTextContent,
  HeroCtaContainer,
  HeroCtaLink,
} from './Hero.styles'

import heroImage from '../../../../../../../public/assets/product/hero.png'
import heroImageMobile from '../../../../../../../public/assets/product/hero-m.png'
import sinceForeverBadge from '../../../../../../../public/assets/product/since-forever.png'
import Link from 'next/link'

export const Hero: React.FC = () => {
  const { t } = useTranslation()

  return (
    <HeroRoot>
      <HeroContent>
        <HeroImage>
          <Image priority={true} src={heroImage} alt={t('products:hero.imageAlt')} className="desktop-image" />
        </HeroImage>
        <HeroImageMobile>
          <Image priority={true} src={heroImageMobile} alt={t('products:hero.imageAlt')} className="mobile-image" />
        </HeroImageMobile>
        <HeroTextContent>
          <HeroTitle>{t('products:hero.title')}</HeroTitle>
          <HeroSubtitle>{t('products:hero.subtitle')}</HeroSubtitle>
          <HeroBadge className="mobile-only">
            <Image src={sinceForeverBadge} alt={t('products:hero.badgeAlt')} />
          </HeroBadge>
        </HeroTextContent>
        <HeroBadge className="desktop-only">
          <Image src={sinceForeverBadge} alt={t('products:hero.badgeAlt')} />
        </HeroBadge>
      </HeroContent>
    </HeroRoot>
  )
}
